import React, { useEffect, useState } from "react";
import { TrendingUp, ShoppingBag, Users, Shirt, Clock, RotateCcw, AlertTriangle, Percent, IndianRupee } from "lucide-react";
import api from "@/lib/api";
import { money } from "@/context/StoreContext";
import { AdminCard } from "./AdminLayout";

const CARDS = [
  ["todays_sales", "Today's Sales", IndianRupee, true],
  ["total_revenue", "Total Revenue", TrendingUp, true],
  ["orders", "Orders", ShoppingBag],
  ["customers", "Customers", Users],
  ["products", "Products", Shirt],
  ["pending_orders", "Pending Orders", Clock],
  ["pending_returns", "Pending Returns", RotateCcw],
  ["low_stock", "Low Stock", AlertTriangle],
  ["conversion_rate", "Conversion Rate", Percent, false, true],
];

export default function Dashboard() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/admin/dashboard").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {CARDS.map(([k, label, Icon, isMoney, isPct]) => (
          <AdminCard key={k}>
            <div className="flex items-center justify-between">
              <span className="text-xs uppercase tracking-widest text-sharoa-muted">{label}</span>
              <Icon size={16} className="text-sharoa-rose" />
            </div>
            <p className="font-serif text-3xl mt-2" data-testid={`stat-${k}`}>{isMoney ? money(s[k] || 0) : isPct ? `${s[k] || 0}%` : (s[k] ?? 0)}</p>
          </AdminCard>
        ))}
      </div>
    </div>
  );
}
